var map = {
	"./briefcase": "D39o",
	"./briefcase.js": "D39o",
	"./building-nature": "pZk2",
	"./building-nature.js": "pZk2",
	"./buildings": "E/yD",
	"./buildings-modern": "/qUl",
	"./buildings-modern.js": "/qUl",
	"./buildings.js": "E/yD",
	"./button-loop": "vp7V",
	"./button-loop.js": "vp7V",
	"./check-custom": "iREz",
	"./check-custom.js": "iREz",
	"./coin-stacks": "pg68",
	"./coin-stacks.js": "pg68",
	"./gift-box": "b5z1",
	"./gift-box.js": "b5z1",
	"./house-garage": "Bbzm",
	"./house-garage.js": "Bbzm",
	"./maps-pin": "KYQw",
	"./maps-pin.js": "KYQw",
	"./money-bag-euro": "Ces7",
	"./money-bag-euro.js": "Ces7",
	"./ranking-people": "OpNe",
	"./ranking-people.js": "OpNe",
	"./shield": "Q8Ux",
	"./shield.js": "Q8Ux",
	"./social-facebook": "nAiM",
	"./social-facebook.js": "nAiM",
	"./social-instagram": "iGK3",
	"./social-instagram.js": "iGK3",
	"./social-linkedin": "Q1Ot",
	"./social-linkedin.js": "Q1Ot",
	"./social-twitter": "LYXH",
	"./social-twitter.js": "LYXH",
	"./social-web": "X88r",
	"./social-web.js": "X88r",
	"./three-columns": "i1/j",
	"./three-columns.js": "i1/j",
	"./users-circle": "oly5",
	"./users-circle.js": "oly5",
	"./woman-graduate": "IfzO",
	"./woman-graduate.js": "IfzO"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "twbT";